export const CHILDCARE_REFERRAL_POST_BOOKING_IAM_SHOWN_AT_STORAGE_KEY =
  "childcare-referral-post-booking-iam-shown-at";

export const DEFAULT_CHILDCARE_REFERRAL_POST_BOOKING_IAM_COPY = {
  title: "Refer a childcare professional, earn a bonus!",
  body: "Know a Lead or Assistant Teacher who'd love picking up shifts like this? Share your referral link and you'll both earn $150 when they work their first shift!",
  ctaText: "Refer a Friend",
};

export const DEFAULT_CHILDCARE_REFERRAL_POST_BOOKING_IAM_CONFIG = {
  enabled: false,
  msas: ["Chicago-Naperville-Elgin, IL-IN-WI"],
  workplaceTypes: ["Child Care Center"],
  frequencyCapInDays: 7,
  copy: DEFAULT_CHILDCARE_REFERRAL_POST_BOOKING_IAM_COPY,
};
